import { matchPath } from "react-router-dom";

/**
 routes that must stay reachable without a session.

 Single source of truth: routes/index.js builds routesForNotAuthenticatedOnly from
 this list, and the global 401 handler in backendServices/ApiCalls.js exempts these
 paths from the forced redirect to /login. Keeping both consumers on one list is what
 stops a newly added public route from silently becoming unreachable while logged out.
 **/
export const anonymousRoutePaths = [
    "/login",
    "/login/:token/:email",
    "/forget-password",
    "/reset-password/:token/:email",
    // Keeps malformed reset links on the public recovery screen. React Router
    // ranks the complete two-segment route above this fallback.
    "/reset-password/*",
];

export const isAnonymousRoutePath = (pathname) =>
    typeof pathname === "string" &&
    anonymousRoutePaths.some((pattern) => matchPath(pattern, pathname) !== null);
